import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }
const _hoisted_7 = ["disabled"]

import { ref, onMounted, onUnmounted, watch } from 'vue';


import { defineComponent, computed } from 'vue';
const __default__ = defineComponent({
  name: 'BaseModal'
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    id: {},
    title: {},
    size: { default: 'md' },
    dialogClass: { default: '' },
    showCloseButton: { type: Boolean, default: true },
    closeButtonText: { default: 'Close' },
    showSaveButton: { type: Boolean, default: true },
    saveButtonText: { default: 'Save changes' },
    saveButtonClass: { default: 'btn-primary' },
    saveButtonDisabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false }
  },
  emits: ["close", "save", "shown", "hidden"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const sizeClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'modal-sm';
    case 'lg':
      return 'modal-lg';
    case 'xl':
      return 'modal-xl';
    case 'full':
      return 'modal-fullscreen';
    case 'md':
    default:
      return '';
  }
});

const modalElement = ref<HTMLElement | null>(null);
let bootstrapModalInstance: any = null;

const initBootstrapModal = () => {
  const bootstrap = (window as any).bootstrap;
  if (bootstrap && bootstrap.Modal && modalElement.value) {
     // Ensure only one instance exists
    if (bootstrapModalInstance) {
        bootstrapModalInstance.dispose();
    }
    bootstrapModalInstance = new bootstrap.Modal(modalElement.value, {
      backdrop: 'static', // Optional: prevent closing by clicking backdrop
      keyboard: false     // Optional: prevent closing by ESC key
    });

    // Listen to Bootstrap's native events
    modalElement.value.addEventListener('shown.bs.modal', () => emit('shown'));
    modalElement.value.addEventListener('hidden.bs.modal', () => emit('hidden'));
  }
};

const show = () => {
  if (bootstrapModalInstance) {
    bootstrapModalInstance.show();
  } else {
    // Fallback if Bootstrap JS fails or isn't ready yet
    if (modalElement.value) {
       modalElement.value.classList.add('show');
       modalElement.value.style.display = 'block';
       document.body.classList.add('modal-open');
       if (!document.querySelector('.modal-backdrop')) {
         const backdrop = document.createElement('div');
         backdrop.className = 'modal-backdrop fade show';
         document.body.appendChild(backdrop);
       }
       emit('shown'); // Emit shown event for fallback
    }
  }
};

const hide = () => {
  if (bootstrapModalInstance) {
    bootstrapModalInstance.hide();
  } else {
    // Fallback hiding
    if (modalElement.value) {
       modalElement.value.classList.remove('show');
       modalElement.value.style.display = 'none';
       document.body.classList.remove('modal-open');
       const backdrop = document.querySelector('.modal-backdrop');
       if (backdrop) backdrop.remove();
       emit('hidden'); // Emit hidden event for fallback
    }
  }
};

// Watch for visibility changes from parent
watch(() => props.visible, (newVal) => {
  if (newVal) {
    show();
  } else {
    hide();
  }
});

onMounted(() => {
   initBootstrapModal();
   // If visible prop is true on mount, show the modal
   if (props.visible) {
       show();
   }
});

onUnmounted(() => {
    if (bootstrapModalInstance) {
        bootstrapModalInstance.dispose();
        bootstrapModalInstance = null;
    }
});

// Expose methods to parent components
__expose({ show, hide });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: __props.id,
    tabindex: "-1",
    "aria-labelledby": `${__props.id}Label`,
    "aria-hidden": "true",
    ref_key: "modalElement",
    ref: modalElement
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", [sizeClass.value, __props.dialogClass]]),
      role: "document"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", {
            class: "modal-title",
            id: `${__props.id}Label`
          }, _toDisplayString(__props.title), 9, _hoisted_4),
          _createElementVNode("button", {
            class: "btn-close py-0",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "body")
        ]),
        _createElementVNode("div", _hoisted_6, [
          (__props.showCloseButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-secondary",
                type: "button",
                "data-bs-dismiss": "modal",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              }, _toDisplayString(__props.closeButtonText), 1))
            : _createCommentVNode("", true),
          (__props.showSaveButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["btn save_btn", __props.saveButtonClass]),
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save'))),
                disabled: __props.saveButtonDisabled
              }, _toDisplayString(__props.saveButtonText), 11, _hoisted_7))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "footer")
        ])
      ])
    ], 2)
  ], 8, _hoisted_1))
}
}

})